import { Checkbox } from '@mui/material';
import React, { useState } from 'react';

const ControlledCheckbox = ({
  defaultChecked,
  onChange,
}) => {
  const [checked, setChecked] = useState(defaultChecked);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    onChange(event);
  };

  return (
    <Checkbox
      checked={checked}
      onChange={handleChange}
    />
  );
};

export default ControlledCheckbox;
